

export function urlValidate(url) {
   if(!url) return '';
   url = url.trim();
   if(!/^https?:\/\//i.test(url)){ 
     url = 'https://' + url;
     return url;
   }else{
     return url;
   }
}